<template>

  <section class="Send__password__reset__email0010">
    <el-row :gutter="0" class="Send__password__reset__emailHead">
      <router-link to="/sp/0001" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="Send__password__reset__emailSpan">パスワードリセットメール送信</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="Send__password__reset__emailBody">
      <el-form ref="form" :model="getform0022" :rules="rules" label-width="100px">
        <el-form-item label="企業コード" prop="companycode">
          <el-input v-model="getform0022.companycode"></el-input>
        </el-form-item>
        <el-form-item label="ユーザーID" prop="userid0020">
          <el-input v-model="getform0022.userid0020"></el-input>
        </el-form-item>
        <div class="inquiry__btn">
        <el-button type="primary" @click="onSubmit('form')" plain >送信</el-button>
        <el-button type="info" @click="goBack('form')" plain>戻る</el-button>
      </div>
      </el-form>
    </el-row>
  </section>

</template>

<script>
//import Common from '../../common/CommonFunc.js'
import { mapGetters } from "vuex";
import router from '../../router';
import Vue from 'vue'
import json from "../../components/config.json";
  export default  {
    name: 'Send__password__reset__email0010',
    props: [],
    mounted () {
     this.getform0022.companycode = this.$route.params.credentials.contract_code;
     this.getform0022.userid0020 = this.$route.params.credentials.user_id;

    },
    
    data () {
      var confirmLengthinput1 = (rule, value, callback) => {
     var passCheck= this.getform0022.companycode;
       //   alert(passCheck.length);
           if (passCheck.length > 12) {
             callback(new Error('Enter confirm length of password'));
           } 
           else {
             callback();
           }
   };
    var confirmLengthinput2 = (rule, value, callback) => {
   var passCheckLength= this.getform0022.userid0020;
       //   alert(passCheck.length);
           if (passCheckLength.length > 256) {
             callback(new Error('Enter confirm 20 char of password'));
           } 
           else {
             callback();
           }
   };
   

      return {
        form: {
          companycode: '',
          userid0020: ''
      },
      rules: {
        companycode: [
           { required: true,type:"string", message: '企業コードを入力してください。'},
           {  validator: confirmLengthinput1, message: '企業コードは12文字以下を入力してください。'},
           { pattern:/^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/,message:'企業コードは半角英数字を入力してください。'},
            { pattern:/^[/\u3040-\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9]+$/,message:'企業コードは記号を入力できません。'}
   ],
   userid0020: [
           { required: true,type:"string", message: 'ユーザーIDを入力してください。'},
           {  validator: confirmLengthinput2, message: 'ユーザーIDは256文字以下を入力してください。'},
           {  pattern: /^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/, message: 'ユーザーIDは半角英数字を入力してください。'}
          ],
     }
     }
      
    },
    methods: {
      //create password reset link
    onSubmit(formName) {
this.$LogButtonEvent("0022","Send");
this.$LogMethodIN("0022","onSubmit");       
      this.$refs[formName].validate((valid) => {
          if (valid) {
            var credential = {
                            contract_code: this.getform0022.companycode,
                            user_id:this.getform0022.userid0020
            };

             console.log(credential);
             this.$store.dispatch('sp_Communication0022/resetPassword',credential).then(() => {
             
            var status = this.getStatus;

              if(status == 0){
                    this.$alert(json["0022_transmission_success_message"], json["0022_transmission_success_title"], {
                      confirmButtonText: 'OK',
                    });
                    var time = new Date();
                   Vue.prototype.$session.set('time', time);
                    this.$refs[formName].resetFields();
                  }else{
                    this.$alert(this.getMsgDetail, json["0022_transmission_failure_title"], {
                      confirmButtonText: 'OK',
                    });
                    this.$refs[formName].resetFields();
                  }
              
           })
          } else {
             console.log('error submit!!');
            return false;
          }
        });
        this.$LogMethodOut("0022","onSubmit");
    },
    goBack(){
this.$LogButtonEvent("0022","Return");
this.$LogMethodIN("0022","goBack");        
      this.getform0022.companycode = '';
      this.getform0022.userid0020 = '';
      
      router.push({name:"sp_0006"});
      
      this.getform0006.contract = '';
      this.getform0006.user = '';
      this.getform0006.pass = '';
      this.$LogMethodOut("0022","goBack");
    }
    },
    computed: {...mapGetters("sp_Situation0022", [
      "getform0022",
      "getStatus",
    "getMsgDetail"]),
    ...mapGetters("sp_Situation0006", [
			"getform0006",
		])
  },
 created(){
    //Common.Session.CheckIsMobile("/sp/0022","/0022"); // MobileScreen Path, WebScreen Path
 }
}


</script>
<style scoped>
 @import "0022.css";
 @import "../../assets/css/customStyle.css"; 
</style>